import {
  addNavMenuItem,
  PageLocationId,
  registerPageTab,
} from "@bb-vendure/admin-ui/core";
import SmsTemplateComponent from "./components/sms-template/template.component";
import SmsHistoryListComponent from "./components/sms-history/list.component";

export default [
  // addNavMenuItem(
  //   {
  //     id: "sms-template",
  //     label: "SMS Templates",
  //     routerLink: ["/extensions/sms"],
  //     icon: "envelope",
  //   },
  //   "notifications"
  // ),

  registerPageTab({
    location: "notification-history" as PageLocationId,
    tab: "nav.sms-history",
    route: "/extensions/sms-history",
    tabIcon: "envelope",
    component: SmsHistoryListComponent,
  }),
  registerPageTab({
    location: "notification-template-list" as PageLocationId,
    tab: "nav.sms-template",
    route: "/extensions/sms-templates",
    tabIcon: "envelope",
    component: SmsTemplateComponent,
  }),
];
